/**
 * CSSを参照できない場合のカラーコード定数ファイル
 */
const color = {
  WHITE: '#ffffff', // 白
  // 教科のラベル色
  SUBJECT_KO: '#efab56', // 国語
  SUBJECT_SU: '#77bbff', // 算数・数学
  SUBJECT_EI: '#bc99cc', // 英語
  SUBJECT_RI: '#99bb55', // 理科
  SUBJECT_SY: '#bb9988', // 社会

  // グラフ
  TOTAL_BORDER: '#f9a31b', // 全国平均の線色
  TOTAL_BACKGROUND: 'rgba(255, 255, 124, 0.5)', // 全国平均の背景色
  LOCAL_BORDER: '#f52d79', // 塾・教室平均の線色
  LOCAL_BACKGROUND: 'rgba(0, 0, 0, 0)', // 塾・教室平均の背景色
}

Object.freeze(color)
export default color
